<template>
    <nav>
        <v-toolbar app class="bg_navbar">
            <v-toolbar-side-icon class="text_navbar--text" @click="drawer = !drawer"></v-toolbar-side-icon>
            <v-toolbar-title class="text-uppercase text_navbar--text hidden-xs-only">
                <span class="title font-weight-black">СДТ</span>
                <span class="caption font-weight-light"> прайс-лист</span>
            </v-toolbar-title>
            <div id="left-nav-btns" class="hidden-sm-and-down">
                <v-layout row>
                    <v-btn :ripple="false" flat color="text_navbar" to="/about">
                        <v-icon left medium>domain</v-icon>
                        <span>О компании</span>
                    </v-btn>
                    <v-btn :ripple="false" flat color="text_navbar" to="/promo">
                        <v-icon left medium>monetization_on</v-icon>
                        <span>Акции</span>
                    </v-btn>
                </v-layout>
            </div>

            <v-spacer></v-spacer>

            <Order></Order>
            <v-btn  id="price-nav-btn" class="primary hidden-sm-and-down"
                    v-if="$route.path!=='/'" :ripple="false"
                    flat dark to="/">
                <span>Прайс-лист</span>
                <v-icon right medium>list_alt</v-icon>
            </v-btn>
            <v-btn id="mob-price-nav-btn" class="primary hidden-md-and-up"
                    v-if="$route.path!=='/'" :ripple="false"
                    flat dark icon to="/">
                <v-icon>list_alt</v-icon>
            </v-btn>
            <CatalogRoot></CatalogRoot>
            <Auth></Auth>
        </v-toolbar>

        <v-navigation-drawer v-model="drawer" app class="bg_drawer" width="250px">
            <v-layout column wrap>
                <v-flex>
                    <v-card>
                        <v-img @click="drawer = !drawer"
                            src="/content/logo.png"
                            height="100px" contain/>
                        <v-card-text>
                            <p class="mb-0 text-uppercase body-2">Вы вошли как:</p>
                            <p class="mb-0 body-2 primary--text">
                                {{is_logged_in ? user_info.name_owner : "Анонимный пользователь"}}
                            </p>
                            <p class="mb-0 caption text-lowercase body-2 secondary--text">
                                {{is_logged_in ? user_info.user.email : ""}}
                            </p>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-divider></v-divider>

            <v-list dark>
                <v-list-tile
                        v-for="drawer_item in drawer_items"
                        :key="drawer_item.text"
                        router :to="drawer_item.route"
                        :disabled="!is_logged_in && drawer_item.need_auth"
                >
                    <template v-if="drawer_item.type !== 'divider'">
                        <v-list-tile-action>
                            <v-icon large
                                    v-bind:class="{
                                'text_drawer_disabled--text' : !is_logged_in && drawer_item.need_auth,
                                'text_drawer_primary--text': is_logged_in || !drawer_item.need_auth}"
                            >{{drawer_item.icon}}
                            </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title
                                    v-bind:class="{'subheading': true,
                                'text_drawer_disabled--text' : !is_logged_in && drawer_item.need_auth,
                                'text_drawer_primary--text': is_logged_in || !drawer_item.need_auth}"
                            >{{drawer_item.text}}
                            </v-list-tile-title>
                            <v-list-tile-sub-title
                                    v-if="!is_logged_in && drawer_item.need_auth"
                                    class="warning--text caption">требуется вход
                            </v-list-tile-sub-title>
                        </v-list-tile-content>
                    </template>
                    <template v-else>
                        <v-divider class="info"></v-divider>
                    </template>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
    </nav>
</template>

<script>
    import Auth from '@/components/Auth';
    import Order from '@/components/Order';
    import CatalogRoot from '@/components/CatalogRoot'

    export default {
        name: "Navbar",
        data() {
            return {
                drawer: false,
                drawer_items: [
                    { type: 'link', icon: 'list_alt', text: 'Прайс-лист', route: '/', need_auth: false },
                    { type: 'link', icon: 'domain', text: 'О компании', route: '/about', need_auth: false },
                    { type: 'link', icon: 'monetization_on', text: 'Акции', route: '/promo', need_auth: false },
                    { type: 'divider', icon: '', text: 'divider', route: '', need_auth: false},
                    { type: 'link', icon: 'account_box', text: 'Профиль', route: '/account', need_auth: true },
                    { type: 'link', icon: 'receipt', text: 'Заказы', route: '/orders', need_auth: true },
                ],
            }
        },
        computed: {
            is_logged_in() { return this.$store.getters.logged_state },
            user_info() { return this.$store.getters.user_info_get},
        },
        components: {
            Auth,
            Order,
            CatalogRoot,
        },
    }
</script>

<style scoped>

</style>